import { API_DEVICE_ORDERS } from "../../constants/apis";
import { COMPONENT, DEVICE_ORDERS } from "../../constants/constants";
import { TSet } from "../common/useSet";
import { showConfetti } from "../../components/elements/ConfettiView";
import { reloadData } from "../../components/lists/ListHandler";
import { InfoBox } from "../../components/elements/Elements";
import { currencyFormat } from "../../utils/helpers";

export const useConfirmDeliveryForm = ({ state }: any) => {
  const order = state || {};
  const { id: orderId, device } = order;

  const fields = [
    {
      type: COMPONENT,
      component: (
        <div className="textCenter flexColumn gap10 p10">
          <div className="font40">📦</div>
          <div className="font16 bold textDark">Confirm Device Delivery</div>
          <div className="font13 grey">
            Please confirm that you have received your{" "}
            <b>{device?.name}</b> in good condition.
          </div>
        </div>
      ),
    },
    {
      type: COMPONENT,
      component: (
        <InfoBox color="#b45309">
          By confirming delivery, you acknowledge that you have received the
          device and it is in acceptable condition. Your monthly installment
          payments will begin as scheduled.
        </InfoBox>
      ),
    },
  ];

  const onSubmit = (): TSet => {
    return {
      api: `${API_DEVICE_ORDERS}${orderId}/confirm-delivery/`,
      params: {},
      method: "POST",
      successMessage: { message: "Delivery confirmed!", duration: 5 },
      onSuccess: () => {
        reloadData(DEVICE_ORDERS);
        showConfetti();
      },
    };
  };

  return {
    fields,
    onSubmit,
    title: "Confirm Delivery",
    submitText: "I Confirm Delivery",
  };
};